import { Component, OnInit, AfterViewInit, ViewChild, ElementRef, ViewContainerRef } from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { Location } from "@angular/common";
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { AuthenticactionService } from 'src/app/_services/authentication.service';
import { SessionService } from 'src/app/_services/session.service';
import { DocumentSigningService } from "../../_services/document-signing.service";
import { AppConfig } from '../../app.config';
import Swal from "sweetalert2";
import 'datatables.net';

declare var $: any;

@Component({
    selector: 'app-document-pending',
    templateUrl: './document-pending.component.html',
    styleUrls: ['./document-pending.component.scss']
})
export class DocumentPendingComponent implements OnInit {
    @ViewChild('fileUploadFirma') fileUploadFirma: ElementRef;
    private externalUser = null;
	public user: any = {};
    private table_dSignature_files: any;
    public thisTable: string = 'table-document-pending';
    public del_id: any;
    public rejectObs: string;
    public register_id: any;
    public description_file:string = '';
    public showPdfModal: boolean = false;
    public currentPdfUrl: SafeResourceUrl = '';

    constructor(
        public config: AppConfig,
        public _sessionService: SessionService,
        public authService: AuthenticactionService,
        public router: Router,
        private documentSigningService: DocumentSigningService,
        private sessionService: SessionService,
        private sanitizer: DomSanitizer
    ){}

    public ngOnInit() {
        this.user = this.sessionService.getItem(AppConfig.CLERK_DATA);
        let self: any = this;
		if (this.table_dSignature_files) {
            this.table_dSignature_files.destroy();
        }

        $('body').unbind()
            .on('click', '#open-preview', function (e: any) {
                self.exportHTML($(this).data('id'));
                Swal.fire({
                    title: 'Previsualización en curso',
                    text: 'Se inició el proceso para visualizar el documento.',
                    icon: 'success',
                    allowOutsideClick: false,  // No se cierra al hacer clic fuera
                    allowEscapeKey: false,     // No se cierra con ESC
                    showConfirmButton: false,  // Ocultar botón de confirmar
                    didOpen: () => {
                        Swal.showLoading();
                    }
                })
            })
            .on('click', '.downloadDSF', function () {
                self.download_DSFile($(this).data('id'));
                Swal.fire({
                    title: 'Descarga en curso',
                    text: 'Se inició el proceso de descarga.',
                    icon: 'success',
                    allowOutsideClick: false,  // No se cierra al hacer clic fuera
                    allowEscapeKey: false,     // No se cierra con ESC
                    showConfirmButton: false,  // Ocultar botón de confirmar
                    didOpen: () => {
                        Swal.showLoading();
                    }
                })
            })
            .on('click', '.authorizationDSF', function () {
                self.authorization_DSFile($(this).data('id'));
            })
            .on('click', '.disableDSF', function () {
                Swal.fire({
                    title: 'Ingrese el motivo del rechazo.',
                    input: 'text',
                    icon: 'warning',
                    inputAttributes: {
                        autocapitalize: 'off'
                    },
                    showCancelButton: true,
                    confirmButtonText: 'Aceptar',
                    cancelButtonText: 'Cancelar',
                    allowOutsideClick: false,
                    didOpen: () => {
                        const input = Swal.getInput();
                        input.addEventListener('input', () => {
                            Swal.getConfirmButton().disabled = input.value.trim() === '';
                        });
                    },
                    preConfirm: (name) => {
                        return new Promise((resolve) => {
                            setTimeout(() => {
                                if (!name || name.trim() === '') {
                                    Swal.showValidationMessage('Por favor, debe ingresar un motivo de rechazo');
                                } else {
                                    resolve(name);
                                }
                            }, 500); // Simulando una pequeña carga de validación
                        });
                    }
                  }).then((result) => {
                    if (result.value) {
                        let id: any = $(this).data('id');
                        let obs: any = result.value;
                        let params= {};
                        params['reject'] = {'id': id, 'obs': obs};
                        self.documentSigningService.rejectSign(params).then(send =>{
                            let datos:any = JSON.parse(send);
                            if (datos['texto']['status']=='200'){
                                Swal.fire({
                                    title: 'Procesando...',
                                    html: `La solicitud de firma a sido rechazada por el siguiente motivo: ${result.value}.`,
                                    icon: 'warning',
                                    allowOutsideClick: false,
                                    allowEscapeKey: false,
                                    showConfirmButton: true
                                });
                            }else{
                                // Mensaje de alerta sobre error.
                                Swal.fire({
                                    title: 'Error!',
                                    text: 'Error ' + datos['texto']['status'] + ': '+ datos['texto']['error'],
                                    icon: 'error',
                                    confirmButtonText: 'Aceptar'
                                });
                                self.errorResponse('Error ' + datos['texto']['status'] + ': '+ datos['texto']['error']);
                            }
                            self.initDatatableDSignatureDocument();

                        }).catch(e=>{console.log(e)})
                    }
                  });
            })
        ;
    }

    ngAfterViewInit() {
        this.initDatatableDSignatureDocument();
    }

    ngDoCheck(){
        if (this.externalUser === null) {
            this.externalUser = this.sessionService.getItem(AppConfig.CLERK_DATA);
        }
    }

    private async initDatatableDSignatureDocument() {
        let self: any = this;
        let table: any = $('.' + self.thisTable + '');
        let identifier = self.externalUser.internal_data['identifier'];
        let data: any = {status: 0, user_signature: identifier};
        let result: any = await this.documentSigningService.getDocument(data);
        let datos_json=JSON.parse(result);
        let options: any = {
            paging: true,
            lengthChange: true,
            searching: true,
            ordering: true,
            order: [[0, 'desc']],
            info: true,
            scrollX: true,
            lengthMenu: [
                [5, 10, 15, 25, 50, 100, -1],
                [5, 10, 15, 25, 50, 100, 'Todos'],
            ],
            pageLength: 10,
            language: {
                sProcessing: '<i class=\'fa fa-circle-o-notch fa-spin\'></i> Procesando Información...',
                sLengthMenu: '<span style="margin-bottom: 1rem; display: block;">Mostrar _MENU_ registros</span>',
                sZeroRecords: 'No se encontraron resultados',
                sEmptyTable: 'No hay datos para mostrar por el momento.',
                sInfo: '<span style="margin-bottom: 1rem; display: block;">Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros</span>',
                sInfoEmpty: '<span style="margin-bottom: 1rem; display: block;">Mostrando registros del 0 al 0 de un total de 0 registros</span>',
                sInfoFiltered: '(filtrado de un total de _MAX_ registros)',
                sInfoPostFix: '',
                sSearch: 'Buscar:',
                sUrl: '',
                sInfoThousands: ',',
                sLoadingRecords: 'Cargando...',
                oPaginate: {
                    sFirst: 'Primero',
                    sLast: 'Último',
                    sNext: 'Siguiente',
                    sPrevious: 'Anterior'
                },
                oAria: {
                    sSortAscending: ': Activar para ordenar la columna de manera ascendente',
                    sSortDescending: ': Activar para ordenar la columna de manera descendente'
                }
            },
            data: datos_json.texto,
            columns: [
                {
                    data: "id"
                },
                {
                    data: "rename"
                },
                {
                    data: "user_request"
                },
                {
                    data: "created_at"
                },
                {
                    data: "status_txt",
                    render: function (data, type, row, meta) {
                        let status = '';
                        if (row.status == 0) {
                            status = '<span class="badge bg-warning">Pendiente</span>';
                        } else if (row.status == 2) {
                            status = '<span class="badge bg-info">Firma Jefatura</span>';
                        } else if (row.status == 1) {
                            status = '<span class="badge bg-success">Firmado</span>';
                        } else if (row.status == -3) {
                            status = '<span class="badge bg-danger">Rechazado</span>';
                        }
                        return status;
                    }
                },
                {
                    className: "text-center",
                    width: "120px",
                    targets: 0,
                    data: null,
                    render: (data, type, row, meta) => {
                        let options: string = '';
                        options += '<span title="Previsualizar documento" data-toggle="tooltip">' +
                                        '<a class="btn btn-info btn-sm circle-button" id="open-preview" data-id="' + data.id_multisignature_data + '" data-toggle="modal" data-target="#">' +
                                            '<i class="fa fa-magnifying-glass" aria-hidden="true"></i>' +
                                        '</a>' +
                                    '</span> ';
                        if (data.status!=0){
                            options += '<span title="Descargar" data-toggle="tooltip">' +
                                            '<a class="btn btn-primary btn-sm downloadDSF circle-button" data-id="' + data.id_multisignature_data + '" data-toggle="modal" data-target="#">' +
                                                '<i class="fa fa-download" aria-hidden="true"></i>' +
                                            '</a>' +
                                        '</span>';
                        }

                        if (data.status==0){
                            options += '<span title="Autorizar" data-toggle="tooltip">' +
                                            '<a class="btn btn-success btn-sm authorizationDSF circle-button mx-2" data-id="' + data.id + '" data-toggle="modal" data-target="#" >' +
                                                '<i class="fa fa-check" aria-hidden="true"></i>' +
                                            '</a>' +
                                        '</span>';
                            options += '<span title="Rechazar" data-toggle="tooltip">' +
                                            '<a class="btn btn-danger btn-sm disableDSF circle-button" data-id="' + data.id + '" data-toggle="modal" data-target="#">' +
                                                '<i class="fa fa-ban" aria-hidden="true"></i>' +
                                            '</a>' +
                                        '</span>';
                        }
                        return options;
                    }
                }
            ]
        };

        if (this.table_dSignature_files) {
            this.table_dSignature_files.destroy();
        }
        this.table_dSignature_files = table.DataTable(options);
    }

    public authorization_DSFile(id){
        let run_authorization = this.externalUser.internal_data['identifier'];
        let params= {};
        let fullname_authorization = this.externalUser.internal_data['names']+" "+this.externalUser.internal_data['last_name'];
        params['authorization'] = {'id': id, 'run_authorization': run_authorization, 'name_authorization': fullname_authorization};
        // Swal con opción para descargar el archivo
        Swal.fire({
            title: 'Autorización de firma',
            text: '¿Autorizar la firma de este documento?',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Aceptar',
            cancelButtonText: 'Cancelar'
        }).then((result) => {
            if (result.value) {
                Swal.fire({
                    title: 'Procesando...',
                    html: 'Se inició el proceso de autorización. Por favor, no cierres esta pestaña hasta que haya finalizado.',
                    icon: 'warning',
                    allowOutsideClick: false,
                    allowEscapeKey: false,
                    showConfirmButton: false,
                    didOpen: () => {
                        Swal.showLoading();
                    }
                });
                this.documentSigningService.authSign(params).then(send =>{
                    let datos:any = JSON.parse(send);
                    if (datos['texto']['status']=='200'){
                        // Swal con opción para descargar el archivo
                        Swal.fire({
                            title: 'Documento firmado correctamente',
                            text: '¿Desea descargar el documento?',
                            icon: 'success',
                            showCancelButton: true,
                            confirmButtonColor: '#3085d6',
                            cancelButtonColor: '#d33',
                            confirmButtonText: 'Descargar',
                            cancelButtonText: 'Cancelar'
                        }).then((result) => {
                            if (result.value) {
                                this.description_file = datos['texto']['description'];
                                this.download_DSFile(datos['texto']['id']);
                                this.successResponse('Se ha iniciado la descarga del documento.','¡Descarga en curso!');
                            }
                        });
                    }else{
                        // Mensaje de alerta sobre error.
                        Swal.fire({
                            title: 'Error!',
                            text: 'Error ' + datos['texto']['status'] + ': '+ datos['texto']['error'],
                            icon: 'error',
                            confirmButtonText: 'Aceptar'
                        });
                        this.errorResponse('Error ' + datos['texto']['status'] + ': '+ datos['texto']['error']);
                    }
                    this.initDatatableDSignatureDocument();

                }).catch(e=>{console.log(e)})
            }
        });
    }

    public download_DSFile(id){
        const url = `${this.config.BASE_API_URL}/digital_signature_files/download_file/${id}?token=${this.config.API_TOKEN}`;

        // Usar fetch para detectar cuando se completa la descarga
        fetch(url, {
            method: 'GET',
            headers: {
                'Accept': 'application/pdf'
            }
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            return response.blob();
        })
        .then(blob => {
            // Crear URL del blob
            const blobUrl = window.URL.createObjectURL(blob);

            // Crear link de descarga
            const link = document.createElement('a');
            link.href = blobUrl;
            link.download = this.description_file || `documento_${id}.pdf`;
            link.target = '_blank';

            // Agregar al DOM temporalmente para asegurar compatibilidad
            document.body.appendChild(link);
            link.click();

            // Limpiar después de un pequeño delay
            setTimeout(() => {
                document.body.removeChild(link);
                window.URL.revokeObjectURL(blobUrl);
                Swal.close();
            }, 1000);
        })
        .catch(error => {
            console.error('Error en descarga:', error);
            Swal.close();

            // Mostrar error específico según el tipo
            if (error.message.includes('404')) {
                this.errorResponse('El archivo no se encontró en el servidor.');
            } else if (error.message.includes('403')) {
                this.errorResponse('No tienes permisos para descargar este archivo.');
            } else if (error.message.includes('500')) {
                this.errorResponse('Error interno del servidor. Intenta nuevamente.');
            } else {
                this.errorResponse('Error al descargar el archivo. Verifica tu conexión a internet.');
            }
        });
    }

    private successResponse(message: string, title: string): void {
        // this.toast.success(message, title);
    }

    private errorResponse(_error?: string): void {
        let error = _error || 'Ocurrió un error al guardar.';
        // this.toast.error(error, 'Error!');
        Swal.fire({
            title: 'Error',
            text: error,
            icon: 'error',
            showCancelButton: false,
            confirmButtonColor: '#3085d6',
            confirmButtonText: 'Aceptar'
        })
    }

    private async exportHTML(id) {
        const self = this;
        const xhr = new XMLHttpRequest();
        xhr.open('POST', (self.config.BASE_API_URL + '/digital_signature_files/get_preview_document'), true);
        xhr.setRequestHeader('Content-Type', 'application/json');
        xhr.responseType = 'blob';

        xhr.onload = async function () {
            if (xhr.status === 200) {
                const blob = xhr.response;
                const url = window.URL.createObjectURL(blob);
                self.openPdfModal(url);
            } else if(xhr.status === 410){
                // Mensaje de alerta sobre error.
                Swal.fire({
                    title: 'Error!',
                    text: 'Faltan los datos del proveedor. Por favor, ingreselos en el módulo "Sistema Adquisiciones".',
                    icon: 'error',
                    confirmButtonText: 'Aceptar'
                });
                console.error('Faltan los datos del proveedor.');
                self.errorResponse('Error: status-> ' + xhr.status + ', detalle-> Faltan los datos del proveedor.');
            }else {
                console.error('Error al descargar el archivo.');
                self.errorResponse();
            }
            Swal.close();
        };

        xhr.send(JSON.stringify({
            'id': id
        }));
    }

    private openPdfModal(pdfUrl: string) {
        // Cerrar cualquier SweetAlert activo antes de abrir el modal
        Swal.close();

        // Usar modal de Angular
        this.currentPdfUrl = this.sanitizer.bypassSecurityTrustResourceUrl(pdfUrl);
        this.showPdfModal = true;
    }

    public closePdfModal() {
        this.showPdfModal = false;
        this.currentPdfUrl = '';
    }

    public async refreshDatatableFromDOM() {
        await this.initDatatableDSignatureDocument();
    }
}
